import { NgModule, LOCALE_ID, ErrorHandler } from "@angular/core";
import { FlexLayoutModule } from '@angular/flex-layout';
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from '@ng-select/ng-select';
import { registerLocaleData } from '@angular/common';
import localeFi from '@angular/common/locales/fi';
registerLocaleData(localeFi);
import localeSv from '@angular/common/locales/sv';
registerLocaleData(localeSv);
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { TreeModule } from 'primeng/tree'; // Import PrimeNG Tree
import { AppErrorHandler } from './app-error.handler';
import { NgxSpinnerModule } from "ngx-spinner";
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OrganizationComponent } from './components/organization/organization.component';
import { OrganizationService } from './services/organization.service';
import { TimeConverterComponent } from './components/time-converter/time-converter.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SharedMaterialModule } from './shared-mat.module';

@NgModule({
  imports: [
    SharedMaterialModule,
    FlexLayoutModule,
    CommonModule,
    NgSelectModule,
    FormsModule, ReactiveFormsModule,
    TreeModule, // PrimeNG Tree
    BsDatepickerModule,
    NgxSpinnerModule,
    NgxDatatableModule,
    TranslateModule,
    NgbModule,
    TooltipModule.forRoot(),
    ModalModule.forRoot()
  ],
  declarations: [
    OrganizationComponent,
    TimeConverterComponent
  ],
  providers: [
    { provide: ErrorHandler, useClass: AppErrorHandler },
    { provide: LOCALE_ID, useValue: "fi" },
    OrganizationService
  ],
  exports: [
    SharedMaterialModule,
    FlexLayoutModule,
    CommonModule,
    NgSelectModule,
    BsDatepickerModule,
    NgxSpinnerModule,
    NgxDatatableModule,
    OrganizationComponent,
    TimeConverterComponent,
    TranslateModule,
    FormsModule, ReactiveFormsModule,
    TreeModule,
    NgbModule,
    ModalModule,
    TooltipModule
  ]
})
export class SharedModule {
}


